import { Interweave } from '@/components/common/Interweave';
import { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import EllipsisMain from './Ellipsis';

export interface EllipsisProps {
  content: string;
  ellipsis?: boolean;
  dangerouslyUseInnerHTML?: boolean;
  maxLine?: number;
  visibleLine?: number;
  maxHeight?: number;
  visibleHeight?: number;
  ellipsisNode?: ReactNode;
  endExcludes?: string[];
  reflowOnResize?: boolean;
  onReflow?: (ellipsis: boolean, text: string) => void;
  onEllipsisClick?: () => void;
  className?: string;
  expendedClassName?: string;
}

const Ellipsis: FC<EllipsisProps> = props => {
  const { content, expendedClassName } = props;
  const [contentkey, setContentkey] = useState<number>(-1);

  const [isExpended, setIsExpended] = useState<boolean>(false);

  useEffect(() => {
    setContentkey(prevState => {
      return ~prevState;
    });
  }, [content]);

  const handleEllipsisClick = useCallback(() => {
    setIsExpended(true);
    !!props?.onEllipsisClick && props?.onEllipsisClick();
  }, [setIsExpended]);

  return (
    <>
      {!isExpended && <EllipsisMain key={`content-${contentkey}`} {...props} onEllipsisClick={handleEllipsisClick} />}
      {isExpended && (
        <Interweave content={content} className={expendedClassName}>
          {content}
        </Interweave>
      )}
    </>
  );
};

export default Ellipsis;
